import React from 'react'

const EndsWith = ({ property, onChange }) => {
  return (
    <div />
  )
}

export default EndsWith